import { Box, BoxProps } from "@chakra-ui/react";
import { useEffect, useRef } from "react";

type Props = { id: string; autoplay: boolean; backgroundMode: boolean; muted: boolean; containerStyles?: BoxProps }

const TrailerVimeo = ({ id, autoplay, backgroundMode, muted, containerStyles }: Props) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!ref.current) return
    const params = new URLSearchParams({
      autoplay: autoplay ? "1" : "0",
      muted: backgroundMode ? "1" : "0",
      controls: backgroundMode ? "0" : "1",
      dnt: "1",
      api: "1",
      loop: backgroundMode ? "1" : "0",
      background: backgroundMode ? "1" : "0"
    })
    const html = `<iframe width=\"100%\" height=\"100%\" src=\"https://player.vimeo.com/video/${id}?${params.toString()}\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>`
    ref.current.innerHTML = html
  }, [id, autoplay, backgroundMode])

  useEffect(() => {
    const iframe = ref.current?.querySelector("iframe") as HTMLIFrameElement | null
    if (!iframe) return
    try {
      const volumeCmd = { method: "setVolume", value: muted ? 0 : 1 }
      iframe.contentWindow?.postMessage(volumeCmd, "*")
      if (!backgroundMode && !muted) {
        const playCmd = { method: "play" }
        iframe.contentWindow?.postMessage(playCmd, "*")
      }
    } catch (_) {}
  }, [muted, backgroundMode])

  return (
    <Box
      ref={ref}
      position="relative"
      sx={{ aspectRatio: "16/9", iframe: { width: "100%", height: "100%", border: "none" } }}
      {...containerStyles}
    />
  )
}

export default TrailerVimeo
